import { render, staticRenderFns } from "./EditIVR.vue?vue&type=template&id=73c7915a&scoped=true&"
import script from "./EditIVR.vue?vue&type=script&lang=js&"
export * from "./EditIVR.vue?vue&type=script&lang=js&"
import style0 from "./EditIVR.vue?vue&type=style&index=0&id=73c7915a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c7915a",
  null
  
)

export default component.exports